jQuery(function($){
	$("#search-autocomplete").focusin(function() {
		if(!$(this).val()){
			$("#search-top-destinations").show();
		}
	});
	$(window).click(function () {
		$("#search-top-destinations").hide();
	});
	$('#search-autocomplete, #search-top-destinations').click(function (event) {
		event.stopPropagation();
	});
	$("#search-autocomplete").keyup(function(){
		if(!$(this).val()){
			$("#search-top-destinations").show();
		} else {
			$("#search-top-destinations").hide();
		}
	});
	$("#search-autocomplete").keyup(function(event) {
		if (event.which === 13) {
			if( typeof $("#eac-container-search-autocomplete ul li:first-child a").attr("href") != 'undefined') {
				$("#eac-container-search-autocomplete ul li:first-child a").click();
				window.location = $("#eac-container-search-autocomplete ul li:first-child a").attr("href");
			}
		}
	});
});

if ($( "#search-autocomplete" ).length) {
	var easyAutocomplete = require('easy-autocomplete');
	var options = {
		data: autocompleteData,
		getValue: "name",
		template: {
			type: "custom",
			method: function(value, item) {
				return "<a href='" + item.link + "' class='" + item.icon + "'>" + value +"</a>";
			}
		},
		list: {
			maxNumberOfElements: 1000,
			match: {
				enabled: true,
			},
			onLoadEvent: function () {
				if ($("#eac-container-search-autocomplete").val() !== '') {
					var elementCount = $("#eac-container-search-autocomplete").getElementCount();
					if (elementCount <= 0) {
						$('#no-results').show();
					}
					else {
						$('#no-results').hide();
					}
				}
			}
		},
		highlightPhrase: false,
		noResults: 'No results found, please try again',
	};
	$("#search-autocomplete").easyAutocomplete(options);
}


jQuery(function($) {
	if ($( "#duration-range" ).length) {
		var noUiSlider = require("nouislider");
		var slider = document.getElementById("duration-range");
		noUiSlider.create(slider, {
			start: [3, 30],
			connect: true,
			step: 1,
			range: {
				min: 3,
				max: 30,
			},
		});

		// Any slider changes should update the numbers shown above it
		slider.noUiSlider.on("update", function() {
			var values = slider.noUiSlider.get();

			$(".low-nights > span").text(Math.trunc(values[0]));
			$(".high-nights > span").text(Math.trunc(values[1]));
		});

		function handleFilters(page = 1) {
			var filter = $("#filter");

			// Get the form data
			var data = filter.serializeArray();

			// Add the duration range
			var duration = slider.noUiSlider.get();
			data.push({
				name: "duration_start",
				value: duration[0],
			});
			data.push({
				name: "duration_end",
				value: duration[1],
			});

			// Add the sort value (if selected)
			var sort = $("#filter-sort").val();
			if (sort != "") {
				data.push({
					name: "sort",
					value: sort,
				});
			}

			// Add the page
			data.push({
				name: "page",
				value: page,
			});

			// Perform the ajax request
			$.ajax({
				url: filter.attr("action"),
				data: data, // form data
				type: filter.attr("method"), // POST
				dataType: "json", // conver the response from JSON
				beforeSend: function(xhr) {
					$("#response").addClass("loading"); // add a loading class
				},
				success: function(data) {
					$("#response").removeClass("loading"); // remove the loading class

					// If this is page 1, overwrite all data and insert
					if (page == 1) {
						$("#response .itineraries-filter-results-row").html(data.html);
					} else {
						// Otherwise remove any existing "Load More" buttons, and append the new data
						$(".load-more").remove();
						$("#response .itineraries-filter-results-row").append(data.html);
					}

					// Different wording depending on count
					if (data.count == 1) {
						$("#response .result-count").text("1 itinerary");
					} else {
						$("#response .result-count").text(data.count + " itineraries");
					}

					// We also need to add a listener to a potential "Load More" button
					// If the load more button is pressed, submit the filters, but provide a page number
					$(".load-more").click(function() {
						var page = $(this).data("page");
						handleFilters(page);
					});
				},
			});
		}

		$("#filter").submit(function() {
			// Submit the filters and handle the response, return page 1
			handleFilters();
			return false;
		});

		// Clear filters when requested
		$(".clear-filters").click(function() {
			// Get the related field name
			var field = $(this).data("field");

			if (field == "duration-range") {
				// Slider is handlded differently
				slider.noUiSlider.set([3, 30]);
			} else {
				// Otherwise just uncheck all boxes
				$(`input[name="${field}"]`).prop("checked", false);
			}

			// Trigger a change event to refire the AJAX
			$("#filter").change();
		});

		// Update the filter results on any changes
		$("#filter").change(function() {
			$("#filter").submit();
		});

		// Update the filter results on any sorting changes
		$("#filter-sort").change(function() {
			$("#filter").submit();
		});

		// Update the filter resultson any range slider changes
		slider.noUiSlider.on("change", function() {
			$("#filter").submit();
		});

		// Run the filter on page load
		$("#filter").submit();

		//
		// Destination Accordions
		//
		$(".continent-title").click(function() {
			$(this).toggleClass("filter-accordion-open");
			$(this).next(".continent-options").slideToggle(200);
		});

		//
		// Mobile Accordions
		//
		$(".filter-heading").next(".filter-checkboxes").slideToggle(0);
		$(".filter-heading").click(function() {
			$(this).toggleClass("mobile-accordion-open");
			$(this).next(".filter-checkboxes").slideToggle(200);
		});

		//
		// Custom Select Menu for Sorting
		//
		// Iterate over each select element
		$(".custom-select").each(function() {
			// Cache the number of options
			var $this = $(this),
			numberOfOptions = $(this).children("option").length;
			// Hides the select element
			$this.addClass("s-hidden");
			// Wrap the select element in a div
			$this.wrap('<div class="select"></div>');
			// Insert a styled div to sit over the top of the hidden select element
			$this.after('<div class="styled-select"></div><div class="sort-shrowd"></div>');
			// Cache the styled div
			var $styledSelect = $this.next("div.styled-select");
			// Show the first select option in the styled div
			$styledSelect.text(
				$this
				.children("option")
				.eq(0)
				.text()
			);
			// Insert an unordered list after the styled div and also cache the list
			var $list = $("<ul />", {
				class: "options",
			}).insertAfter($styledSelect);
			// Insert a list item into the unordered list for each select option
			for (var i = 0; i < numberOfOptions; i++) {
				$("<li />", {
					text: $this
					.children("option")
					.eq(i)
					.text(),
					rel: $this
					.children("option")
					.eq(i)
					.val(),
				}).appendTo($list);
			}
			// Cache the list items
			var $listItems = $list.children("li");
			// Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
			$styledSelect.click(function(e) {
				e.stopPropagation();
				$("div.styled-select.active").each(function() {
					$(this)
					.removeClass("active")
					.next("ul.options")
					.hide();
				});
				$(this)
				.toggleClass("active")
				.next("ul.options")
				.toggle();
			});
			// Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
			// Updates the select element to have the value of the equivalent option
			$listItems.click(function(e) {
				e.stopPropagation();
				$styledSelect.text($(this).text()).removeClass("active");
				$this.val($(this).attr("rel"));
				$this.change();
				$list.hide();
			});
			// Hides the unordered list when clicking outside of it
			$(document).click(function() {
				$styledSelect.removeClass("active");
				$list.hide();
			});
		});
	}
});
